export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-accordion/_content-section-accordion.twig";